import {NgModule}                           from '@angular/core';
import {ApCropGroupsOverviewComponent}      from './components/cropgroups/ap-cropgroups.component';
import {CommonModule}                       from '@angular/common';
import {ApCoreModule}                       from '../ap-core/ap-core.module';
import {
  BodyModule,
  GridModule,
  GroupModule,
  HeaderModule,
  PagerModule,
  SharedModule
}                                           from '@progress/kendo-angular-grid';
import {ApTranslationModule}                from '../translation/ap-translation.module';
import {ButtonsModule}                      from '@progress/kendo-angular-buttons';
import {ApSettingsRoutes}                   from './ap-settings.routes';
import {ApLoggerComponent}                  from './components/logger/ap-logger.component';
import {ApMachinesLoggerComponent}          from './components/machineslogger/ap-machines-logger.component';
import {ApLoggerSettingsComponent}          from './components/ap-logger-settings.component';
import {TabStripModule}                     from '@progress/kendo-angular-layout';
import {ApDynformsModule}                   from '../ap-dynforms/ap-dynforms.module';
import {ApAccessPermissionsComponent}       from './components/access-permissions/ap-access-permissions.component';
import {ApLicenceComponent}                 from './components/licence-management/ap-licence.component';
import {ReactiveFormsModule}                from '@angular/forms';
import {ComboBoxModule}                     from '@progress/kendo-angular-dropdowns';
import {ApUtilsModule}                      from '../ap-utils';
import {ApResponsiveTextModule}             from '../ap-responsive-text/ap-responsive-text.module';
import {ApSectionHeaderModule}              from '../ap-section-header/ap-section-header.module';
import {ApTooltipModule}                    from '../ap-tooltip/ap-tooltip.module';
import {ApDynComponentModule}               from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApUserProfileEditComponent}         from './components/user-profile/ap-userprofile-edit.component';
import {ApUserSettingsComponent}            from './components/user-settings/ap-usersettings.component';
import {ApUserProfileUserSettingsComponent} from './components/ap-userprofile-usersettings.component';
import {ApPermissionModule}                 from '../ap-permission/ap-permission.module';

@NgModule({
  declarations: [
    ApCropGroupsOverviewComponent,
    ApLoggerComponent,
    ApMachinesLoggerComponent,
    ApLoggerSettingsComponent,
    ApAccessPermissionsComponent,
    ApLicenceComponent,
    ApUserProfileEditComponent,
    ApUserSettingsComponent,
    ApUserProfileUserSettingsComponent
  ],
  imports: [
    CommonModule,
    GridModule,
    ApCoreModule,
    BodyModule,
    HeaderModule,
    SharedModule,
    ApTranslationModule,
    ButtonsModule,
    GroupModule,
    PagerModule,
    ApSettingsRoutes,
    TabStripModule,
    ApDynformsModule,
    ReactiveFormsModule,
    ComboBoxModule,
    ApUtilsModule,
    ApResponsiveTextModule,
    ApTooltipModule,
    ApSectionHeaderModule,
    ApDynComponentModule,
    ApPermissionModule,
  ],
  exports: [
    ApCropGroupsOverviewComponent,
    ApLoggerComponent,
    ApMachinesLoggerComponent,
    ApLoggerSettingsComponent,
    ApAccessPermissionsComponent,
    ApLicenceComponent,
    ApUserProfileEditComponent,
    ApUserSettingsComponent,
    ApUserProfileUserSettingsComponent
  ]
})
export class ApSettingsModule {
}
